const initialState = {
    dashboardData: [],
    loading: false,
    error: null,
};
const CentralMonitoringScreenReducer = (state = initialState, action) => {
    switch (action.type) {
        case "FETCH_DATA_REQUEST":
            return {
                ...state,
                loading: true,
                error: null
            };
        case "CENTRAL_MONITOR_DATA_SUCCESS":
            return {
                ...state,
                dashboardData: action.payload,
                loading: false,
                error: null,
            };
        case "FETCH_DATA_COMPLETE":
            return {
                ...state,
                loading: false,
                error: null,
            };
        case "CENTRAL_MONITOR_DATA_FAILURE":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default CentralMonitoringScreenReducer;
